import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BotConfiguration from '../entities/botConfiguration'

interface BotConfigurationState extends ListState<BotConfiguration> {
    botConfiguration: BotConfiguration,
    editBotConfiguration: BotConfiguration,
    pegasMinPrice: number | null,
}

class BotConfigurationMutations extends ListMutations<BotConfiguration> {
}

class BotConfigurationModule extends ListModule<BotConfigurationState, any, BotConfiguration> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BotConfiguration>(),
        loading: false,
        editBotConfiguration: {} as BotConfiguration,
        selectBotConfiguration: {} as BotConfiguration,
        pegasMinPrice: null,
    }

    actions = {
        async getBotConfigurations(context: ActionContext<BotConfigurationState, any>) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Admin/GetBotConfigurations');
            context.state.loading = false;
            
            // Eğer response.data.result bir array ise direkt ata, değilse PageResult olarak işle
            if (Array.isArray(response.data.result)) {
                context.state.list = response.data.result;
                context.state.totalCount = response.data.result.length;
            } else {
                let page = response.data.result as PageResult<BotConfiguration>;
                context.state.totalCount = page.totalCount;
                context.state.list = page.items;
            }
        },

        async saveBotConfiguration(context: ActionContext<BotConfigurationState, any>, payload: any) {
            await Ajax.post('/api/services/app/Admin/SaveBotConfiguration', payload.data);
        },

        async getPegasMinPrice(context: ActionContext<BotConfigurationState, any>) {
            let response = await Ajax.get('/api/services/app/Admin/GetPegasMinPrice');
            context.state.pegasMinPrice = response.data.result;
        },

        async setPegasMinPrice(context: ActionContext<BotConfigurationState, any>, payload: any) {
            await Ajax.post(`/api/services/app/Admin/SetPegasMinPrice?price=${payload.price}`);
        },
    };

    mutations = {
        setCurrentPage(state: BotConfigurationState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BotConfigurationState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const botConfigurationModule = new BotConfigurationModule();
export default botConfigurationModule;
